






















import { computed, defineComponent } from '@vue/composition-api';
import ElButton                      from 'element-ui/lib/button';
import { Computed }                  from '@/types';

export default defineComponent({
  name: 'cButton',
  components: {
    ElButton,
  },
  props: {
    buttonStyle: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const buttonClass: Computed<string> = computed(() => `c-button--${props.buttonStyle}`);

    return {
      buttonClass,
    };
  },
});
